import React from "react";
import ReactDOM from "react-dom/client";
import "styles/index.css";
import "styles/design-system.css";
import App from "./App";
import ReactGA from "react-ga4";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import sentryConfig from "./config/sentry";
import store from "./state/store";
import mixpanel from "mixpanel-browser";
import { bootstrapClientSession } from "utils/sessionBootstrap.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

(() => {
  ReactGA.initialize(process.env.REACT_APP_G_TAG_ID);

  const mixpanelToken = process.env.REACT_APP_MIXPANEL_TOKEN;
  if (mixpanelToken) {
    mixpanel.init(mixpanelToken, {
      debug: true,
      track_pageview: true,
      persistence: "localStorage",
    });
  } else {
    console.warn(
      "REACT_APP_MIXPANEL_TOKEN not found. Mixpanel will not be initialized."
    );
  }

  // Persist organization + API base URL for SPA and HTML forms.
  bootstrapClientSession();

  // Initialize Sentry
  // Sentry.init(sentryConfig);

  if (process.env.NODE_ENV !== "development") console.log = () => {};
})();
